export default function login(state = {}, action) {
    switch (action.type) {
        case "LOGIN":
            return Object.assign({}, state, {
                updated: new Date().getTime()
            }, action.payload || { });
        default:
            return state;
    }
}
